import { CaretLeft } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import { api } from '../../../../../services/api'
import { type Column } from '../../../../../components/Table'
import { SearchInput } from '../../../../../components/SearchInput'
import { TableWithManuallyPagination } from './components/TableWithManuallyPagination'
import { Medias } from '../../../../../enumns/medias'
import { useMediaQuery } from '../../../../../hooks/useMediaQuery'
import { TableWithInfiniteScroll } from './components/TableWithInfiniteScroll'
import clsx from 'clsx'

export const ClientContacts = () => {
  const navigate = useNavigate()
  const isMinScreenWidthMD = useMediaQuery(`(min-width: ${Medias.MD}px)`)

  const { id } = useParams()

  const [filters, setFilters] = useState({
    page: 1,
    take: isMinScreenWidthMD ? 10 : 20,
    search: '',
  })

  const { data: client } = useQuery(['clients', id], async () => {
    const response = await api.get(`/clients/${id}`)
    return response.data
  })

  const handleSearchClientContact = (searchTerm: string) => {
    setFilters((prevState) => ({
      ...prevState,
      page: 1,
      search: searchTerm,
    }))
  }

  const columns = [
    {
      field: 'id',
      isVisible: false,
    },
    {
      field: 'name',
      headerName: 'Contato',
      widthInPercentage: 40,
    },
    {
      field: 'email',
      headerName: 'E-mail',
      widthInPercentage: 50,
    },
    {
      field: 'phone',
      headerName: 'Telefone',
      widthInPercentage: 10,
    },
  ] as Column[]

  useEffect(() => {
    if (isMinScreenWidthMD) {
      setFilters((prevState) => ({
        ...prevState,
        page: 1,
      }))
      return
    }

    if (!isMinScreenWidthMD) {
      setFilters((prevState) => ({
        ...prevState,
        take: 20,
        page: 1,
      }))
    }
  }, [isMinScreenWidthMD])

  return (
    <>
      <div className="md:flex md:justify-between md:items-center md:mb-6">
        {!isMinScreenWidthMD && (
          <button className="mb-10 text-grey-700" onClick={() => navigate(-1)}>
            <CaretLeft size={32} />
          </button>
        )}

        <div
          className={clsx('text-grey-900 gap-4', {
            'flex items-center': isMinScreenWidthMD,
            'mb-4': !isMinScreenWidthMD,
          })}
        >
          {isMinScreenWidthMD && (
            <button onClick={() => navigate(-1)}>
              <CaretLeft size={24} />
            </button>
          )}

          <h1 className="text-base font-medium md:text-lg">{client?.name}</h1>
        </div>

        <SearchInput
          onSearch={handleSearchClientContact}
          placeholder="Buscar por nome"
          className="mb-6 md:w-96 md:mb-0"
        />
      </div>

      {isMinScreenWidthMD ? (
        <TableWithManuallyPagination
          columns={columns}
          filters={filters}
          clientId={Number(id)}
          setFilters={setFilters}
        />
      ) : (
        <TableWithInfiniteScroll
          clientId={Number(id)}
          columns={columns}
          filters={filters}
        />
      )}
    </>
  )
}
